import useSWRImmutable from "swr/immutable";
import { useApi } from "../api";
import { CustomError } from "../errors";
import { HrailSettings } from "./types/hrailSettings";

export const useHrailSettings = (signal: AbortSignal, configurationId?: string) => {
  const api = useApi();
  const url = `/settings/hrail${configurationId ? `?configuration_id=${configurationId}` : ""}`;
  return useSWRImmutable<HrailSettings, CustomError, string>(url, (url) =>
    api.get<HrailSettings>({ url, signal }),
  );
};
